import View from '@/base/views/view';

class CustomerView extends View {

    static table = 'customer';

    static getTableOptions () {
        return {
            fields: [
                { name: 'id', label: 'id'},
                { name: 'Code', label: 'Code', maxLenghth: 10},
                { name: 'Name', label: 'Name'},
                { name: 'ProjectId', label: 'ProjectId', editor: 'vue-select', relation: 'project', optionLabels: 'Name'},
                { name: 'URL', label: 'URL'},
                { name: 'Branch', label: 'Branch'},
                { name: 'Password', label: 'Password'},
                { name: 'DataBase', label: 'DataBase'},
                { name: 'Users', label: 'Cantidad de Usuarios'},
                { name: 'ATTACH_DATA_KEY', label: 'ATTACH_DATA_KEY'},

            ],
            title: 'Customer',
            canAdd: true,
        }
    }

}

export default CustomerView;
